import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { UpdateMemberResponse, UpdateMemberParams } from './types';

export async function updateOrganizationMember(organizationId: string, params: UpdateMemberParams) {
  const url = `/web/studio/organizations/${organizationId}/members`;

  /* eslint-disable camelcase */
  const body: Record<string, unknown> = {
    user_id: params.userId,
  };

  if (params.role !== undefined) body.role = params.role;
  if (params.title !== undefined) body.title = params.title;
  if (params.hasPermissionAccessAnalytics !== undefined) {
    body.has_permission_access_analytics = params.hasPermissionAccessAnalytics;
  }
  /* eslint-enable camelcase */

  const response = await api.executePutRequest<ObjectResponse<UpdateMemberResponse>>(url, body);

  return response.data;
}
